import React from 'react';

import { updateOrderKeys } from '../../../../../helpers/insertItemAtSpecificPositionWithOrderUpdate';

import ConfirmDeletionModalPattern from '../../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeleteTabModal = ({ label, order, setTabs, onClose }) => {
    const handleDelete = () => {
        setTabs((tabs) => {
            const filteredTabs = tabs.filter((tab) => tab.order !== order);
            return updateOrderKeys(filteredTabs);
        });
        onClose();
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Tab"
            handleDelete={handleDelete}
            onClose={onClose}
            confirmationTextStart="Are you sure you want to delete the"
            confirmationTextEnd="Tab?"
            entityName={label}
        />
    );
};

export default DeleteTabModal;
